import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["progress"]
  static values = { timeout: { type: Number, default: 4500 } }

  connect() {
    this.startProgress()
    this.timer = setTimeout(() => this.close(), this.timeoutValue)
  }

  disconnect() {
    clearTimeout(this.timer)
    clearTimeout(this.removeTimer)
  }

  close(event) {
    event?.preventDefault()
    if (this.closing) return

    this.closing = true
    clearTimeout(this.timer)
    this.element.classList.add("opacity-0", "translate-x-2")
    this.removeTimer = setTimeout(() => this.element.remove(), 200)
  }

  startProgress() {
    if (!this.hasProgressTarget) return

    this.progressTarget.style.width = "100%"
    this.progressTarget.style.transition = `width ${this.timeoutValue}ms linear`
    requestAnimationFrame(() => { this.progressTarget.style.width = "0%" })
  }
}
